import {ExtraOptions, RouterModule, Routes} from '@angular/router';
import {NgModule} from '@angular/core';
import {RegisterFormComponent} from './pages/register-form/register-form.component';
import {PrealertComponent} from './pages/prealert/prealert.component';
import {CalculateComponent} from './pages/calculate/calculate.component';
import {TrackingComponent} from './pages/tracking/tracking.component';

export const routes: Routes = [
  {path: 'register', component: RegisterFormComponent},
  {path: 'prealert', component: PrealertComponent},
  {path: 'calculate', component: CalculateComponent},
  {path: 'tracking', component: TrackingComponent},
  {
    path: '',
    redirectTo: 'tracking',
    pathMatch: 'full',
  },
  {path: '**', redirectTo: 'tracking'},
];

const config: ExtraOptions = {
  useHash: false,
};

@NgModule({
  imports: [RouterModule.forRoot(routes, config)],
  exports: [RouterModule],
})
export class AppRoutingModule {
}
